<template>
  <div class="vimeo-cover" ref="container">
    <div class="video-parent" :style="{ width, height, transform }">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  aspect: {
    type: Number,
    default: 0.5625,
  },
});

const container = ref(null);

const elementSize = useElementSize(container);

const containerAspect = computed(() => {
  return elementSize.height.value / elementSize.width.value;
});

const w = computed(() => {
  if (containerAspect.value > props.aspect) {
    return elementSize.height.value / props.aspect;
  } else {
    return elementSize.width.value;
  }
});

const h = computed(() => {
  if (containerAspect.value > props.aspect) {
    return elementSize.height.value;
  } else {
    return elementSize.width.value * props.aspect;
  }
});

const width = computed(() => {
  return `${Math.trunc(w.value)}px`;
});

const height = computed(() => {
  return `${Math.trunc(h.value)}px`;
});

const transform = computed(() => {
  return `translate3d( ${Math.trunc((elementSize.width.value - w.value) / 2)}px, ${Math.trunc(
    (elementSize.height.value - h.value) / 2,
  )}px, 0 )`;
});
</script>

<style scoped lang="scss">
.vimeo-cover {
  overflow: hidden;

  :deep(iframe) {
    width: 100%;
    height: 100%;
  }

  .video-parent {
    min-width: 100%;
    min-height: 100%;
  }
}
</style>
